import React, { useContext, useState } from 'react';

import styled from 'styled-components';
import Form from '../../../../kingpin/forms/Form';
import FormHeader from '../../../../kingpin/forms/FormHeader';
import FormContent from '../../../../kingpin/forms/FormContent';
import FieldOptions, { FieldOptionsType } from './FieldOptions';
import FieldUsage from './FieldUsage';
import Row from '../../../../components/Common/Row';
import { NabTabLinkMargin, NavTabButton } from '../../../../components/NavTab';
import {
  TabContent,
  TabInner,
} from '../../DatasetFilters/SavedFilters/FilterSlideOut/FilterSlideOut';
import { FieldUsageContext } from './FieldUsage/FieldUsage';
import getFieldUsageCount from './FieldUsage/getFieldUsage/getFieldUsageCount';

const FieldsForm = styled(Form)`
  position: fixed;
  right: 0;
  top: 0;
  height: 100vh;
  width: 430px;
  box-shadow:
    0 0 0 1px rgba(53, 45, 67, 0.07),
    -1px 0 3px 0 rgba(53, 45, 67, 0.12),
    -1px 0 12px 5px rgba(53, 45, 67, 0.1);
  display: flex;
  flex-direction: column;
  background-color: var(--color-bg-primary);
`;

const FieldSlideOut = (children: FieldOptionsType) => {
  const [selectedTab, setSelectedTab] = useState<'details' | 'usage'>(
    'details',
  );
  const { usages } = useContext(FieldUsageContext);

  return (
    <FieldsForm data-testid={`${children.field}-slide-out`}>
      <FormHeader title={children.field} onClose={children.onClose} />
      <FormContent>
        <Row style={{ marginBottom: 16 }}>
          <div style={{ marginRight: NabTabLinkMargin }}>
            <NavTabButton
              onClick={() => setSelectedTab('details')}
              isSelected={selectedTab === 'details'}
              title={'Details'}
            />
          </div>
          <div style={{ marginRight: NabTabLinkMargin }}>
            <NavTabButton
              onClick={() => setSelectedTab('usage')}
              isSelected={selectedTab === 'usage'}
              title={`Usages (${getFieldUsageCount(usages[children.field])})`}
            />
          </div>
        </Row>
        <TabContent>
          <TabInner>
            {selectedTab === 'details' && <FieldOptions {...children} />}
            {selectedTab === 'usage' && <FieldUsage field={children.field} />}
          </TabInner>
        </TabContent>
      </FormContent>
    </FieldsForm>
  );
};

export default FieldSlideOut;
